import init from './init.js';

// potrzebne zeby sie komunikowac z iframe ktory uzyl settera domain
// https://developer.mozilla.org/en-US/docs/Web/API/Document/domain#setter
// eslint-disable-next-line no-self-assign
document.domain = document.domain; // NOSONAR

init();
